import {get, isFinite} from "lodash";
import "./resource";
import { SaleService } from "../sale/service";
import { OnlineCaution, onlineT } from "../../typings/online";
import { thor } from "../../typings/thor";

class OnlineContainerService extends SaleService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "$translate",
        "authService",
        "configService",
        "onlineContainerResource",
        "saleTranslationsResource",
        "sitesService",
        "utilsService"
    ];

    constructor(
        $log: ng.ILogService,
        $q: ng.IQService,
        $translate: ng.translate.ITranslateService,
        authService,
        configService,
        onlineContainerResource,
        saleTranslationsResource,
        sitesService,
        utilsService
    ) {
        super(
            $log,
            $q,
            $translate,
            authService,
            configService,
            onlineContainerResource,
            saleTranslationsResource,
            sitesService,
            utilsService
        );
    }

    public createItem(containerId, itemPost) {
        return this.saleResource()
            .createItem(
                { id: containerId },
                itemPost
            )
            .$promise
            .catch(error => {
                this.$log.error(`Error while creating new item on container ${containerId}`, error);
                return this.$q.reject(error);
            });
    }

    public getOnlineContainerLastBids(id) {
        return this.saleResource()
            .getOnlineContainerLastBids({ id })
            .$promise
            .then((lastBids: onlineT.LastBid[]) => {
                this.$log.info("Fetching last-bids data ok : ", lastBids);
                return this.$q.resolve(lastBids);
            })
            .catch(error => {
                this.$log.error(`Error while fetching last-bids of container ${id}`, error);
                return this.$q.reject(error);
            });
    }

    public getOnlineContainerCaution(id) {
        return this.saleResource()
            .getOnlineContainerCaution({ id })
            .$promise
            .then((caution: OnlineCaution) => {
                this.$log.info("Fetching caution data ok : ", caution);
                return this.$q.resolve(caution);
            })
            .catch(error => {
                this.$log.error(`Error while fetching caution of container ${id}`, error);
                return this.$q.reject(error);
            });
    }

    public updateOnlineContainerCaution(id, body) {
        return this.saleResource()
            .updateOnlineContainerCaution({ id }, body)
            .$promise
            .then((caution: OnlineCaution) => {
                this.$log.info("Updating caution data ok : ", caution);
                return this.$q.resolve(caution);
            })
            .catch(error => {
                this.$log.error(`Error while Updating caution of container ${id}`, error);
                return this.$q.reject(error);
            });
    }


    protected checkIfEveryMandatoryFieldsAreFilled(container): boolean {
        return Boolean(
            container.name &&
            container.description &&
            container.start_at &&
            container.datetime &&
            !container.isPast &&
            container.sale_conditions &&
            this.isCommissionRateFilled(container) &&
            this.isShippingFilled(container)
        );
    }

    protected isCommissionRateFilled(container: thor.SaleGet): boolean {
        return isFinite(get(container, "options.commission_rate.voluntary"));
    }
}

angular
    .module("thor.core.online-container.service", [
        "thor.core.online-container.resource"
    ])
    .service("onlineContainerService", OnlineContainerService);
